import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { SHIFT_LABELS } from '@/constants/ui';
import { getStatusColor } from '@/utils/statusUtils';

interface FloatingActionBarProps {
  selectedCount: number;
  onUpdateShift: () => void;
  isUpdating: boolean;
}

export const FloatingActionBar: React.FC<FloatingActionBarProps> = ({
  selectedCount,
  onUpdateShift,
  isUpdating,
}) => {
  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50">
      <div className="bg-white rounded-xl shadow-lg border border-gray-200 px-4 py-2 flex items-center gap-4">
        <div className="flex items-center gap-2">
          <Checkbox
            checked={selectedCount > 0}
            className="h-4 w-4"
          />
          <span className="text-gray-700 font-medium text-sm">
            {selectedCount === 0 ? 'No employees selected' : `${selectedCount} employee${selectedCount !== 1 ? 's' : ''} selected`}
          </span>
        </div>

        <div className="flex items-center gap-2">
          <Button
            size="sm"
            variant="outline"
            className={`flex items-center gap-2 hover:bg-gray-100 ${getStatusColor('neutral', 'light')}`}
            onClick={onUpdateShift}
            disabled={selectedCount === 0 || isUpdating}
          >
            <Plus className="h-4 w-4" />
            {SHIFT_LABELS.UPDATE_SHIFT_BUTTON}
          </Button>
        </div>
      </div>
    </div>
  );
}; 